module.exports = __webpack_public_path__ + "img/layers-two-02.9019d71b.svg";